import React, { Component } from 'react';
import { Translate } from '$common';



export default class LocationStamp extends Component {
  static type = 'location_stamp';
  static elementName = Translate.get('location_stamp');
  static icon = 'map-marker';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/location-stamp.js